const Preloader = () => {
  return (
    <div className="texture3 flex min-h-screen justify-center items-center">
      <div
        data-text="嗎哪罐子"
        className="sm:text-4xl sm:underline-offset-3 sm:before:underline-offset-3 font-bold text-8xl tracking-[0.3em] text-lime-100 underline-offset-8 decoration-wavy decoration-sky-400 before:content-[attr(data-text)attr(data-text)] before:underline before:underline-offset-8 before:decoration-wavy before:decoration-stone-200 relative before:absolute overflow-hidden pb-8 before:whitespace-nowrap before:animate-wave before:text-transparent"
      >
        嗎哪罐子
      </div>
    </div>
  );
};

export default Preloader;
